import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { getHtmlText } from './getHtmlText.js';
const EMPTY_HTML = '<p><br></p>';
export const RichText = JSX((props) => {
    const { __html = '', richVersion = '', itemSize = 'list-m', isDotted = true } = props;
    const dotStyle = isDotted ? '' : 'without-dots';
    return __html && getHtmlText(__html) !== EMPTY_HTML ? (
    /* Attribute [data-component] need for correct render in wcms editor. Do not remove. */
    _jsx("div", { "data-component": "rich-text-container", children: _jsx("div", { className: style(richVersion, itemSize, 'md-container group-data-secondary:text-white group-data-gray:text-secondary-text', dotStyle), dangerouslySetInnerHTML: { __html } }) })) : null;
});
//# sourceMappingURL=RichText.js.map